import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { Card, Empty } from "antd";

export const ChartChannel = ({ data }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const processData = (data) => {
      let salesByChannel = {};
      data?.forEach((item) => {
        const channel = item.channel;
        const saleAmount = item.saleAmount;

        if (!salesByChannel[channel]) {
          salesByChannel[channel] = {
            totalSales: 0,
            orderCount: 0,
            productCount: 0,
          };
        }

        salesByChannel[channel].totalSales += saleAmount;
        salesByChannel[channel].orderCount += 1;

        salesByChannel[channel].productCount += item.products?.reduce(
          (total, product) => total + product.quantity,
          0
        );
      });

      const newChartData = Object.keys(salesByChannel)?.map((channel) => {
        const channelData = salesByChannel[channel];
        return {
          channel,
          totalSales: channelData.totalSales,
          orderCount: channelData.orderCount,
          productCount: channelData.productCount,
          averageTicket: channelData.productCount / channelData.orderCount,
        };
      });

      const sortedChartData = newChartData?.sort((a, b) => b.totalSales - a.totalSales);
      return sortedChartData;
    };

    const processedData = processData(data);
    setChartData(processedData);
  }, [data]);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const { totalSales, productCount, orderCount, averageTicket } =
        payload[0].payload;

      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <b className="intro">{`${label}`}</b>
          <p className="intro">{`Ventas totales: S/ ${totalSales.toFixed(
            2
          )}`}</p>
          <p className="desc">{`Cantidad de órdenes: ${orderCount}`}</p>
          <p className="desc">{`Cantidad de productos: ${productCount}`}</p>
          <p className="desc">{`Ticket promedio: ${averageTicket.toFixed(
            2
          )}`}</p>
        </div>
      );
    }

    return null;
  };

  const renderCustomizedLabel = (props) => {
    const { x, y, value } = props;

    return (
      <text
        x={x + 37}
        y={y - 5}
        fill="#000"
        textAnchor="middle"
        dominantBaseline="start"
        style={{ fontSize: "14px" }}
      >
        {`S/ ${value.toFixed(2)}`}
      </text>
    );
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return chartData.length > 0 ? (
    <Card title=" ">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} margin={{ top: 20, right: 20 }}>
          <CartesianGrid
            strokeDasharray="3 3"
            strokeOpacity={0.5}
            tick={{ fontSize: "15px" }}
          />
          
          <XAxis dataKey="channel" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="totalSales" name="Ventas Totales" fill="#2B767E">
          {windowWidth > 768 && (
            <LabelList dataKey="totalSales" content={renderCustomizedLabel} />
          )}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  ) : (
    <Card title=" ">
      <div
      className="h-72 flex justify-center items-center"
      >
        <Empty description="No hay datos disponibles" />
      </div>
    </Card>
  );
};
